(function() {
    'use strict';
  
    angular
      .module('iqxCore')
      .service('popupSvc', popupSvc)

    function popupSvc(ApiSvc) {
        var svc = this
        svc.send = send
        svc.SendToDivision = SendToDivision


        function send(divisionID=null, staffID=null, personID=null, employmentID=null, vacancyID=null, title='Notification', description=null, cb){
            var popup={}
            if (divisionID){popup.pDivisionID = divisionID}
            if (staffID){popup.pStaffID = staffID}
            if (personID){popup.pPersonID = personID}
            if (employmentID){popup.pEmploymentID = employmentID}
            if (vacancyID){popup.pVacancyID = vacancyID}
            if (title){popup.pTitle = title}
            if (description){popup.pDescription = description}

            return ApiSvc.exec(svc,'call_/NetDivisionPopup',popup, true)
            .then(function(data){
                if(cb){cb(data)}
                return data
            })
        }

        function SendToDivision(division, person=null, title, description, cb){
            return send(division, null, person, null, null, title, description, cb)
        }
    }
})()
